import React, { useState } from 'react';

import { ThemeProvider } from '@alphonsocode/kallos';
import AsyncSelect from 'react-select/async';
import { SingleSelectDW } from './style';

export interface Option {
  value: string;
  label: string;
  path?: string;
}
const customStyles = {
  control: (base: any, state: any) => ({
    ...base,
    borderColor: state.isFocused ? '#006e7d' : '#c3ccd4',
    boxShadow: state.isFocused ? '0 0 0 1.5px #006e7d' : 'none',
    '&:hover': {
      borderColor: state.isFocused ? '#006e7d' : '#c3ccd4',
    },
  }),
  option: (base: any) => ({
    ...base,
    textAlign: 'left',
    fontWeight: 560,
  }),
  singleValue: (base: any) => ({
    ...base,
    textAlign: 'left',
    width: '100%',
    fontWeight: 560,
  }),
  input: (base: any) => ({
    ...base,
    textAlign: 'left',
    fontWeight: 560,
  }),
  placeholder: (base: any) => ({
    ...base,
    textAlign: 'left',
  }),
  menu: (base: any) => ({
    ...base,
    textAlign: 'left',
  }),
};
function SingleSelectDropdown({
  placeholder,
  value,
  loadOptions,
  onChange,
  defaultOptions,
  isLoading,
  setIsOpen,
}) {
  return (
    <SingleSelectDW>
      <AsyncSelect<Option>
        className="singleSelectDW"
        value={value}
        loadOptions={loadOptions}
        onChange={onChange}
        isSearchable
        cacheOptions
        placeholder={placeholder}
        loadingMessage={() => 'Searching...'}
        noOptionsMessage={({ inputValue }) =>
          inputValue ? `No Options` : 'No Options'
        }
        defaultOptions={defaultOptions.slice(0, 50).map(item => ({
          value: item.key ?? item.value,
          label: item.label,
        }))}
        styles={customStyles}
        isLoading={isLoading}
        captureMenuScroll={true}
        menuShouldScrollIntoView={true}
        onMenuOpen={() => setIsOpen(true)}
        onMenuClose={() => setIsOpen(false)}
      />
    </SingleSelectDW>
  );
}

export default SingleSelectDropdown;
